/*
  Barre d'achat collante (mobile).

  Elle apparaît quand le bouton « Ajouter au panier » de la fiche est passé au-dessus de
  l'écran, et disparaît dès qu'il revient : jamais deux boutons d'achat à l'écran. Tant
  qu'elle est cachée, elle est inerte (ni focus clavier, ni lecteur d'écran).

  Elle vit dans le formulaire du produit : son bouton envoie ce même formulaire, et c'est
  product-form-component qui ajoute au panier puis ouvre le tiroir. Le tiroir est une boîte
  de dialogue modale, affichée au-dessus de tout : la barre ne peut pas masquer son bouton.

  En aperçu d'un thème non publié, Shopify pose sa propre barre (« Brouillon ») tout en bas
  de l'écran, par-dessus la nôtre : la barre se pose alors juste au-dessus. En ligne, cette
  barre d'aperçu n'existe pas et le décalage vaut 0.
*/
(() => {
  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      this.anchor = this.closest('form')?.querySelector('.add-to-cart-button');
      if (!this.anchor || !('IntersectionObserver' in window)) return;

      this.hidden = false;
      this.#show(false);

      this.observer = new IntersectionObserver(([entry]) => {
        // Sorti par le haut seulement : un bouton encore plus bas que l'écran n'a pas été vu.
        this.#show(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      this.observer.observe(this.anchor);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.documentElement.classList.remove('has-sticky-buy-bar');
    }

    #show(visible) {
      if (visible) this.#clearPreviewBar();
      this.dataset.state = visible ? 'visible' : 'hidden';
      this.inert = !visible;
      // Réserve sa hauteur en bas de page, pour que le pied de page ne passe pas dessous.
      document.documentElement.classList.toggle('has-sticky-buy-bar', visible);
    }

    // Barre d'aperçu de Shopify : mesurée au moment d'apparaître, car elle peut avoir été
    // réduite ou fermée entre-temps.
    #clearPreviewBar() {
      const preview = document.getElementById('PBarNextFrameWrapper');
      let offset = 0;
      if (preview) {
        const rect = preview.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom >= window.innerHeight - 1) {
          offset = Math.round(window.innerHeight - rect.top);
        }
      }
      this.style.setProperty('--sticky-buy-bar-offset', `${offset}px`);
    }
  }

  if (!customElements.get('sticky-buy-bar')) {
    customElements.define('sticky-buy-bar', StickyBuyBar);
  }
})();
